import { TeaserCollection } from "@innovationnorway/lighthouse-components";
import React from "react";
import { Course } from "../../../main/models/course";
import { useLayout } from "../../hooks/useLayout";
import "./courses.scss";

interface CoursesProps {
  courses: Course[];
  title: string;
  coursesLink: string;
}

const Courses = ({ courses, title, coursesLink }: CoursesProps) => {
  const { translations } = useLayout();
  return (
    <TeaserCollection
      className="courses"
      imageSize="small"
      items={courses.map((course) => ({
        title: course.title,
        description: course.descriptionText,
        image: { src: course.imgSrc, alt: course.imgAlt },
        url: course.href,
        tags: course.tags?.map((tag) => tag.info) ?? [translations.coursesPageTitle]
      }))}
      title={title}
      link={{ title: translations.seeAllRecommendedContent, url: coursesLink }}
      variant="secondary"
    />
  );
};

export default Courses;
